import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-task',
  templateUrl: './contact-task.component.html',
  styleUrls: ['./contact-task.component.scss']
})
export class ContactTaskComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
